import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import SelectorIdentificationTool from '../components/SelectorIdentificationTool';
import PatternSuggestionPanel from '../components/PatternSuggestionPanel';

function ScraperTestPage() {
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Scraper Components Test Page
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                        Selector Identification Tool
                    </Typography>
                    <SelectorIdentificationTool
                        url="https://example.com"
                        config={{ selectors: {} }}
                        onChange={() => { }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                        Pattern Suggestion Panel
                    </Typography>
                    <PatternSuggestionPanel onApplySuggestion={() => { }} />
                </Grid>
            </Grid>
        </Box>
    );
}

export default ScraperTestPage;